<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" @click="goAdd" v-if="isHavePermission('baseUserSalesManager:add')">新增销售人员
      </Button>
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px">刷新</Button>
      <div style="display: flex;align-items: center;float: right;">
        <div class="finance-span" style="display: flex;align-items: center;">
          <label style="display: inline-block;padding: 0 5px;color: #999;">销售人员：</label>
          <Select v-model="searchSalesManager"
                  style="width: 200px"
                  filterable
                  clearable
                  :loading="searchLoading"
                  placeholder="请输入销售人员"
          >
            <Option
                v-for="(option, index) in salesManagerOptions"
                :value="option.id"
                :key="index"
            >{{ option.text }}
            </Option>
          </Select>
        </div>
        <div class="finance-span" style="display: flex;align-items: center;margin-left: 10px;">
          <label style="display: inline-block;padding: 0 5px;color: #999;">收款人：</label>
          <Select v-model="searchRecName"
                  style="width: 200px"
                  filterable
                  clearable
                  :loading="searchLoading"
                  placeholder="请输入收款人">
            <Option
                v-for="(option, index) in recNameOptions"
                :value="option.text"
                :key="index"
            >{{ option.text }}
            </Option>
          </Select>
        </div>
        <Button type="primary" icon="md-search" @click="querySalesManagerList"
                style="border-radius: 5px;margin-left: 5px">搜索
        </Button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix" style="margin-top: 10px;">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          max-height="540"
          border="none"
          align="center"
          :loading="loading"
          :data="listData"
      >
        <vxe-table-column field="id" title="操作" width="90">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="margin-left: 20px;" transfer
                      v-if="isHavePermission('baseUserSalesManager:edit') || isHavePermission('baseUserSalesManager:delete')">
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" @click="goEdit(row)"
                          v-if="isHavePermission('baseUserSalesManager:edit')">编辑
                  </Button>
                  <Button class="button-gengduo" style="color: #ed4014;" @click="commitDelete(row)"
                          v-if="isHavePermission('baseUserSalesManager:delete')">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="salesManager" title="销售人员" show-overflow>
          <template slot-scope="{ row }">
            <span @click="goDetail(row)" style="cursor:pointer;color: #2d8cf0;">{{ row.salesManager }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="recName" title="收款人" show-overflow></vxe-table-column>
        <vxe-table-column field="phoneNum" title="手机号码" show-overflow></vxe-table-column>
        <vxe-table-column field="idcardNum" title="身份证号码" show-overflow></vxe-table-column>
        <vxe-table-column field="bankName" title="开户银行" show-overflow></vxe-table-column>
        <vxe-table-column field="accountNum" title="银行账号" show-overflow></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" show-overflow></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalResult"
          @page-change="handleCurrentChange"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="createModal" title="新增销售人员" width="700" height="500" resize destroy-on-close
               @close="createModal = false" remember>
      <create-sales-manager ref="createModal" @afterSave="afterSave"
                            @close="createModal = false"></create-sales-manager>
    </vxe-modal>
    <vxe-modal v-model="detailModal" :title="detailTitle" width="1300" height="500" resize destroy-on-close
               @close="close" remember>
      <sales-manager-detail ref="detailModal"></sales-manager-detail>
    </vxe-modal>
  </div>
</template>
<script>
import CreateSalesManager from "@/views/authorization/CreateSalesManager";
import SalesManagerDetail from "@/views/authorization/SalesManagerDetail";
import $api from "@/apiProvider";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  components: {CreateSalesManager, SalesManagerDetail},
  data() {
    return {
      loading: false,
      searchLoading: false,
      listData: [],
      createModal: false,
      detailModal: false,
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
      listQuery: {
        page: 1,
        rows: 10
      },
      detailTitle: '',
      salesManagerOptions: [],
      recNameOptions: [],
      searchSalesManager: null,
      searchRecName: null,
    }
  },
  mounted() {
    this.querySalesManagerList();
    this.getList('', 'salesManagerOptions', 'baseUserSalesManager', 'queryLogisticsKeyword', 1);
    this.getList('', 'recNameOptions', 'baseUserSalesManager', 'queryLogisticsKeyword', 2);
  },
  methods: {
    close(){
      this.detailModal = false;
      this.refresh();
    },
    async getList(query, options, url, path, type) {
      let params = {
        columnType: type
      }
      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].get(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          this[options].push(i)
        })
      }
    },
    remoteMethod(query, options, url, path, type) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, type);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    afterSave() {
      this.createModal = false;
      this.refresh();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.querySalesManagerList();
    },
    goAdd() {
      this.createModal = true;
    },
    refresh() {
      this.querySalesManagerList();
      this.getList('', 'salesManagerOptions', 'baseUserSalesManager', 'queryLogisticsKeyword', 1);
      this.getList('', 'recNameOptions', 'baseUserSalesManager', 'queryLogisticsKeyword', 2);
    },
    goDetail(row) {
      this.detailModal = true;
      this.$nextTick(() => {
        this.$refs.detailModal.init(row);
      })
    },
    goEdit(row) {
      this.detailModal = true;
      this.$nextTick(() => {
        this.$refs.detailModal.setUpdate(row);
      })
    },
    commitDelete(row) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.remove(row.id);
        }
      })
    },
    async remove(id) {
      showLoading();
      let res = await $api.baseUserSalesManager.request("removeSalesManager", {id});
      hideLoading()
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.refresh();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    async querySalesManagerList() {
      this.listQuery.salesManagerId = this.searchSalesManager;
      this.listQuery.recName = this.searchRecName;
      this.loading = true;
      let res = await $api.baseUserSalesManager.request("querySalesManagerList", this.listQuery);
      if (res.status === 1) {
        this.listData = res.data.rows;
        this.totalResult = res.data.total;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
        this.loading = false;
      }
    },
  }
}
</script>
<style>

</style>

